import { render, staticRenderFns } from "./ListarObjetivos.vue?vue&type=template&id=7a769c3a&"
import script from "./ListarObjetivos.vue?vue&type=script&lang=js&"
export * from "./ListarObjetivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports